import { useMemo } from 'react';

import {
  InventoryType,
  ITankInfo,
  TankDimensions,
  TankOrientation,
  TankShape,
} from '@scaleaq/sitecontrol-lib';

type Tank = {
  dimensions: TankDimensions;
  tankShape: TankShape;
  density: number;
  alarmLevels: {
    low: number;
    high: number;
  };
  content: string | undefined;
  orientation: TankOrientation;
  sensorRange: {
    min: number;
    max: number;
  };
  level: {
    height: number;
    volume: number;
  };
  tankUnit: string;
  tankIndex: number;
  inventoryType: InventoryType;
  inventoryId: string | undefined;
  controller: string;
  host: string;
};

export const useTankShape = (tankInfo: ITankInfo) => {
  const {
    density,
    highLevelAlarm,
    id,
    levelHeightOutput,
    levelVolumeOutput,
    lowLevelAlarm,
    maxSensorRange,
    minSensorRange,
    orientation,
    tankContent,
    tankIndex,
    dimensions,
    tankShape,
    tankUnit,
    type,
    fields: { controller, host },
  } = tankInfo;

  const tank = useMemo<Tank | null>(() => {
    if (!tankInfo) return null;
    return {
      tankShape,
      dimensions,
      density,
      alarmLevels: {
        low: lowLevelAlarm,
        high: highLevelAlarm,
      },
      content: tankContent,
      orientation,
      sensorRange: {
        min: minSensorRange,
        max: maxSensorRange,
      },
      level: {
        height: levelHeightOutput,
        volume: levelVolumeOutput,
      },
      tankUnit,
      inventoryType: type,
      tankIndex,
      inventoryId: id,
      controller,
      host,
    };
  }, [
    controller,
    density,
    dimensions,
    highLevelAlarm,
    host,
    id,
    levelHeightOutput,
    levelVolumeOutput,
    lowLevelAlarm,
    maxSensorRange,
    minSensorRange,
    orientation,
    tankContent,
    tankIndex,
    tankInfo,
    tankShape,
    tankUnit,
    type,
  ]);

  return { ...tank };
};
